import { render, staticRenderFns } from "./BlockType2Grid.vue?vue&type=template&id=1b4f3aa8&scoped=true"
import script from "./BlockType2Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType2Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType2Grid.vue?vue&type=style&index=0&id=1b4f3aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f3aa8",
  null
  
)

export default component.exports